import { render } from "./PrimaryCTA.vue?vue&type=template&id=fb756c04&scoped=true"
import script from "./PrimaryCTA.vue?vue&type=script&lang=js"
export * from "./PrimaryCTA.vue?vue&type=script&lang=js"

import "./PrimaryCTA.vue?vue&type=style&index=0&id=fb756c04&scoped=true&lang=scss"

import exportComponent from "/builds/cloud/messenger/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb756c04"]])

export default __exports__